import 'material-dashboard/core/bootstrap.bundle.min';
import 'material-dashboard/plugins/perfect-scrollbar.min';
import 'material-dashboard/plugins/bootstrap-notify';

import 'material-dashboard/material-dashboard';
